import React, { useEffect, useState } from "react";
import PageLoader from "../loader/PageLoader";
import {
    ChatText,
    Checks,
    Copy,
    WarningCircle,
    X,
} from "@phosphor-icons/react";
import axiosInstance from "../../api/axiosInstance";
import dayjs from "dayjs";
import { RejectHotel } from "./RejectAPI";
import { CompleteHotel } from "./CompleteAPI";
import {toast} from "react-toastify";
import { formatHotel } from "../../api/hotelTime";

const ConferenceRoom = ({ func, selectedRequest }) => {

    const hotelId = localStorage.getItem("hotelId");

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [remarks, setRemarks] = useState("");
    const [remarksError, setRemarksError] = useState(false);

    const [conferenceRooms, setConferenceRooms] = useState([]); // State to store conference rooms
    const [amount, setAmount] = useState("");
    const [selectedConferenceRoom, setSelectedConferenceRoom] = useState(""); // For selected conference room
    const [guestRequestId, setGuestRequestId] = useState("");
    const [copied, setCopied] = useState(false);


    // Booking Name and Booking Contact Information
    const [bookingData,setBookingData] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axiosInstance.get(
                    `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/conference-room-request`,
                    {
                        params: {
                            guest_request_id: selectedRequest.requestId,
                        },
                    },
                );
                const conferenceResponse = await axiosInstance.get(
                    `/api/v1/hotels/${selectedRequest.hotelId}/conference-rooms`,
                );

                const bookingResponse = await axiosInstance.get(`/api/v1/hotels/${hotelId}/bookings/${selectedRequest.bookingId}`);
                // console.log("Booking Data : ",bookingResponse.data);
                setBookingData(bookingResponse.data);

                let price = (response.data && response.data.total_amount!=null && response.data.total_amount!=undefined) ? response.data.total_amount.toString() : "";
                setAmount(price);

                setData(response.data);
                setRemarks(response.data?.remarks || "");
                setGuestRequestId(response.data?.guest_request_id || "");
                setSelectedConferenceRoom(
                    response.data?.conference_room_id || "",
                ); // Set the room ID, not just the number
                setConferenceRooms(conferenceResponse.data?.data || []); // Store conference rooms
                setLoading(false);
            } catch (err) {
                setErrors({ fetch: "Failed to fetch Conference Room data" });
                setLoading(false);
            }
        };
        fetchData();
    }, [selectedRequest]);

    const { preferred_time } = data || "";
    const inData = preferred_time
        ? formatHotel(preferred_time, "DD MMMM YYYY")
        : "";
    const inTime = preferred_time
        ? formatHotel(preferred_time, "hh:mm A")
        : "";

    const handleRejectRequest = async () => {
        try {
            if(remarks.trim()==="") {
                setRemarksError(true);
                return;
            }

            const request = {
                hotelId: selectedRequest.hotelId,
                bookingId: selectedRequest.bookingId,
                guestRequestId: guestRequestId,
            };
            const response = await RejectHotel(request,remarks);
            if (response) func(false);
        } catch (error) {
            setErrors({
                fetch: "Failed to reject the conference room request",
            });
            console.log(error);
        }
    };


    // Respond to Guest
    const handleRespondToGuest = async () => {
        try {

            setErrors({ fetch: "" });

            
            if((selectedRequest.status==="Pending_Hotel" || selectedRequest.status==="InProgress_Hotel" || selectedRequest.status==="Scheduled_Hotel") && data && data.total_amount){

                if (!selectedConferenceRoom || !amount) {
                    setErrors({ staff: "conference room & amount are required" });
                    return;
                }
    

                const response = await axiosInstance.put(
                    `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/conference-room-request/${data?.id}`,
                    {
                        conference_room_id: selectedConferenceRoom,
                        remarks: remarks,
                        total_amount: parseFloat(amount), // Ensure amount is a valid number
                        
                        conference_room_number: conferenceRooms.find(
                            (room) => room.id === selectedConferenceRoom,
                        )?.number, // Fetching the room number
                    },
                );
            }
            else{
                if (!amount) {
                    setErrors({ staff: "amount are required" });
                    return;
                }
                const response = await axiosInstance.put(
                    `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/conference-room-request/${data?.id}`,
                    {
                  
                        remarks: remarks,
                        total_amount: parseFloat(amount), // Ensure amount is a valid number
                       
                    },
                );
            }
            func(false);
        } catch (error) {
            setErrors({ fetch: "Failed to update Conference Room request" });
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
        });
    };


    // Complete Hotel
    const handleCompleteHotel = async()=>{
        try{
            const request = {
                hotelId: selectedRequest.hotelId,
                bookingId: selectedRequest.bookingId,
                guestRequestId: guestRequestId,
            };
            const response = await  CompleteHotel(request);
            toast.success("Conference Room Request Completed");
            if (response) func(false);
        }catch(error){
            setErrors({ fetch: "Failed to  Complete Conference Room Request" });
            console.log(error);
        }
    }

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
            {loading && <PageLoader />}
            <form
                className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]"
                onSubmit={(e) => e.preventDefault()}
            >
                {/* Header  */}
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold">Conference Room</h2>
                    <button
                        onClick={() => func(false)}
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                {/* Booking Details */}
                <div className="flex items-center justify-between gap-2 mb-1">
                    <div className="w-1/5">
                        <p className="text-[#8C9199] mb-2">Booking ID</p>
                        <div className="flex items-center gap-2 w-[90%]">
                            <p
                                className="truncate"
                                title={data?.booked_room_id || ""}
                            >
                                {data?.booked_room_id || ""}
                            </p>
                            <button
                                onClick={() => handleCopy(data?.booked_room_id)}
                                className="text-gray-500 hover:text-blue-500"
                                title="Copy to clipboard"
                            >
                                {copied ? (
                                    <Checks size={16} />
                                ) : (
                                    <Copy size={16} />
                                )}
                            </button>
                        </div>
                    </div>
                    <div className="w-1/5">
                        <p className="text-[#8C9199] mb-2">No. of People</p>
                        <p>{data?.number_of_people}</p>
                    </div>
                    <div className="w-1/5">
                        <p className="text-[#8C9199] mb-2">Requested Time</p>
                        <p>{inTime}</p>
                    </div>
                    <div className="w-1/5">
                        <p className="text-[#8C9199] mb-2">Duration</p>
                        <p>{data?.duration_hours}</p>
                    </div>
                    <div className="w-1/5">
                        <p className="text-[#8C9199] mb-2">Requested Date</p>
                        <p>{inData}</p>
                    </div>
                </div>

                <div className="flex items-center mt-2 mb-1  gap-2">
                    <div className="w-1/5">
                            <p className="text-[#8C9199] mb-2">Booking Name</p>
                            <div className="flex items-center gap-2 ">
                                <p
                                    className="truncate pr-4"
                                    title={bookingData?.name || 'Booking Name'}
                                >
                                {bookingData?.name || 'Booking Name'}
                                </p>
                            </div>
                    </div>
                    <div className="w-1/5">
                        <p className="text-[#8C9199] mb-2">Booking Contact</p>
                        <div className="flex items-center gap-2 ">
                            <p
                                className="truncate pr-4"
                                title={bookingData?.contact || 'Booking Contact'}
                            >
                              +{bookingData?.contact || 'Booking Contact'}
                            </p>
                        </div>
                    </div>
                </div>

                <div>
                    <p className="mb-1 text-[#8C9199]">Note</p>
                    <p className="flex items-center gap-2 bg-yellow-100 p-1.5 rounded-md text-yellow-700 text-sm">
                        <ChatText size={16} weight="bold" />{" "}
                        {data?.additional_comments || ""}
                    </p>
                </div>


                {/* Conference Room Details */}
                <div className="flex items-center gap-4">
                    
                    {/* Conference Room */}
                    {
                        (selectedRequest.status==="Pending_Hotel" || selectedRequest.status==="InProgress_Hotel" || selectedRequest.status==="Scheduled_Hotel") && data && data.total_amount &&
                        <div className="w-1/2">
                            <p className=" mb-1 text-[#8C9199]">Conference Room</p>
                            <select
                                name="conference_room"
                                id="conference_room"
                                className="border-[1.5px] rounded-md p-1.5 w-full"
                                onChange={(e) => {
                                    setSelectedConferenceRoom(e.target.value);
                                    setErrors({ staff: "" });
                                }}
                                value={selectedConferenceRoom}
                            >
                                <option value="">Select Conference Room</option>
                                {conferenceRooms.map((room) => (
                                    <option key={room.id} value={room.id}>
                                        Room {room.number} - Capacity:{" "}
                                        {room.capacity}
                                    </option>
                                ))}
                            </select>
                        </div>
                    }

                    {/* Price */}
                    <div className="w-1/2">
                        <p className=" mb-1 text-[#8C9199]">
                            Quote Fee for Conference Room
                        </p>
                        <input
                            type="text"
                            placeholder="Enter your fee"
                            className="border-[1.5px] rounded-md p-1.5 w-full"
                            value={amount}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (!isNaN(value) && value >= 0) {
                                    setAmount(value);
                                }
                                setErrors({ staff: "" });
                            }}
                            disabled={data?.status=="InProgress_Hotel" || data?.status==="Scheduled_Hotel"}
                        />
                    </div>

                </div>

                            
                {/* Errors */}
                {errors.staff && (
                    <p className="text-[#ff7378] text-[12px] flex items-center gap-1 p-0.5 -mt-2">
                        <WarningCircle />
                        {errors.staff}
                    </p>
                )}

                {/* Remarks */}
                <div>
                    <p className="text-[#8C9199] mb-1">Remarks</p>
                    <textarea
                        rows={4}
                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:border-blue-400"
                        placeholder="Mention your comment here"
                        value={remarks}
                        onChange={(e)=>{
                            const value = e.target.value;
                            setRemarks(value);
                            setRemarksError(false);
                        }}
                    ></textarea>
                    {remarksError && (
                        <p className="text-[#ff7378] flex gap-1 items-center text-xs mt-1">
                            <WarningCircle size={14} />
                            remarks is required when you reject the request
                        </p>
                    )}
                </div>

                {/* Buttons */}
                <div className="grid grid-cols-3 gap-3 mt-2">
                    <button
                        className="p-2 w-full bg-[#ff7378] rounded-md font-medium hover:bg-[#f75f64] transition duration-150 outline-none"
                        type="button"
                        onClick={handleRespondToGuest}
                    >
                        Respond To Guest
                    </button>
                    <button className="p-2 w-full border-[1.5px] bg-[#73c9ff] rounded-md font-medium hover:bg-[#5fa4f7] transition duration-150 outline-none" onClick={()=>handleCompleteHotel()} >
                        Complete Request
                    </button>
                    <button
                        className="p-2 w-full border-[1.5px] border-red-300 text-[#ff7378] rounded-md font-medium hover:bg-red-50 transition duration-150 outline-none"
                        type="button"
                        onClick={handleRejectRequest}
                    >
                        Reject Request
                    </button>
                </div>

                {errors.fetch && <p className="text-red-500">{errors.fetch}</p>}
                {errors.reject && (
                    <p className="text-red-500">{errors.reject}</p>
                )}
            </form>
        </div>
    );
};

export default ConferenceRoom;
